import { ESIInclude } from "../__shared__/ESIInclude/SimpleESIInclude";

export function Footer() {
  const srcUrl = "/esi/footer";

  return (
    <div data-testid="footer" data-component="Footer">
      <ESIInclude src={srcUrl} id="web-plp-scaffold-ui-footer" />
    </div>
  );
}
